import { Head } from "@inertiajs/react"
import { AppShell } from "@/components/AppShell"
import { Badge } from "@/components/ui/badge"

type PlaceholderProps = {
  title: string
  milestone: number
  description: string
}

export default function Placeholder({ title, milestone, description }: PlaceholderProps) {
  return (
    <>
      <Head title={title}>
        <meta name="description" content={`${title} — coming in milestone ${milestone}.`} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={`${title} — coming in milestone ${milestone}.`} />
      </Head>
      <AppShell>
        <h1>{title}</h1>
        <div className="mt-2">
          <Badge tone="muted">Milestone {milestone}</Badge>
        </div>
        <p className="mt-4 max-w-md text-pretty text-ink-muted">{description}</p>
        <p className="mt-2 max-w-md text-pretty text-ink-muted">
          This surface comes online in milestone {milestone}. For now it's a placeholder so the sidebar nav exists end-to-end.
        </p>
      </AppShell>
    </>
  )
}
